import { useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllVendors, deleteVendor } from "../../services/VendorServices";
import { displayError } from "../../helpers";
import PremiumPageHeader from "../../components/PremiumPageHeader";
import { ListPageFloatingControls } from "../../components/ListPageLayout";

function VendorTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true);  
    const columns = useMemo(
        () => [
            {
                fieldName: 'entity_name', 
                headerName: 'Name'
            },
           
            {
                fieldName: "address",
                headerName: 'Address'
            },
            {
                fieldName: "phone_number",
                headerName: 'Phone Nos'
            },
            {
                fieldName: "mobile_number",
                headerName: 'Mobile Nos'
            },
            {
                fieldName: "email_id",
                headerName: 'EMail'
            },
            {
                fieldName: 'status',
                headerName: 'Status',
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);

    const onEditVendor = (vendorId, event) => {
       
       navigate(`/VendorEdit/${vendorId}/`);
    };

    const onDeleteVendor = (vendorId, event) => {
        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 

            setIsLoading(true);
            deleteVendor(cookies, vendorId)
            .then(response => {
                console.log(`Vendor with id ${vendorId} deleted`);
                Swal.fire('Deleted Successfully!', '', 'success');
                setRefreshKey(oldKey => oldKey +1)
            })
            .catch(error => {
                setIsLoading(false);
                displayError(error.response.data,"Delete Failed");
            });  
            
          
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(r => {

                const csvRow = {
                    entity_name: r.entity_name,
                    address: r.address,
                    phone_number: r.phone_number,
                    mobile_number:r.mobile_number,
                    email_id:r.email_id,
                    status: r.status
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Vendors',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(r => ({
                entity_name: r.entity_name,
                address: r.address,
                phone_number: r.phone_number,
                mobile_number:r.mobile_number,
                email_id:r.email_id,
                status: r.status
            })),
            'Vendors.pdf'
        );
    };

    useEffect(() => {

        getAllVendors(cookies)
        .then( vendorList => {
            const tableData = vendorList.vendor_list
            .map(vendor => ({
                entity_name: vendor.entity_name,
                address: `${vendor.address_1},\n${vendor.address_2},\n${vendor.address_3}`,
                phone_number:vendor.phone_number,
                mobile_number:vendor.mobile_number,
                email_id:vendor.email_id,
                status:vendor.status? "Active":"Inactive",
                id: vendor.id,    
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListPageFloatingControls
                    formLink="/Vendor"
                    addNewLabel="New Vendor"
                    homeLink="/Home"
                />
                <div className="container page-content-rail">
                    <PremiumPageHeader
                        module="PURCHASE"
                        title="List of Vendors"
                        subtitle="Browse, edit, and manage vendor master records."
                        activeNav="view"
                        mainLink="/Vendor"
                        viewLink="/VendorTable"
                        formLink="/Vendor"
                        addNewLabel="New Vendor"
                        homeLink="/Home"
                    />
                    <div className="item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Vendors'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditVendor}
                            onRowDelete={onDeleteVendor}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        />
                </div>
                </div>
                </div> 


            </div>
        </div>

        
    );

}

export default VendorTable;
